import { GQL } from 'src/graphql';
import { AdapterFunc } from 'src/hooks/useEntityAdapter';
import { SalesTeamTypeModel } from 'src/models';

const salesTeamTypeAdapter: AdapterFunc<GQL.SalesTeamTypesModel, SalesTeamTypeModel> = (input) => ({
  id: input.id,
  name: input.name!,
  createdAt: input.createdAt,
  updatedAt: input.updatedAt,
  description: input.description!,
});

export default salesTeamTypeAdapter;
